module.exports = __webpack_public_path__ + "static/media/daycarePlayPalIcon.e6ce1209.png";